import { Injectable } from '@angular/core';
import { HttpService } from '../../../../shared/services/http/http-client.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'



@Injectable({
  providedIn: 'root',
})
export class ModalPagamentoService {
  protected urlBase = environment.url_server;

  constructor(private http: HttpService) { }

  getPedido(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/prepago/pedido/'+data+'/pagamento', null, successHandle, errorHandle);

  }

  generatePDF(codPix: string, razaoSocial: string, cnpj: string, valor: string, qrcode: string){

    const doc = new jsPDF();

    
    const logo = 'assets/images/valecard.png';
    const logoWid = 40;
    const logoHei = 25;
    
    
    const startY = 10 + logoHei + 20;
    
    const now = new Date();
    const timestamp = `Emitido em: ${now.toLocaleDateString('pt-BR')} - ${now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
    
    const pageWidth = doc.internal.pageSize.getWidth();
    const qrCodeSize = 55;
    const qrCodeX = pageWidth - qrCodeSize - 10;
    const qrCodeY = startY + 10;
    const maxPixCodeWidth = pageWidth - qrCodeSize - 30
    const wrappedPixCode = doc.splitTextToSize(codPix, maxPixCodeWidth);
    
    doc.addImage(logo, 'PNG', 10, 10, logoWid, logoHei);
    
    doc.setFillColor(230, 230, 230);
    doc.rect(10, startY, 190, 10, 'F');

    doc.setFontSize(12);
    doc.setTextColor(5, 45, 120);
    doc.text('INFORMAÇÕES QRCODE', 12, startY + 7);

    doc.setFontSize(9);
    doc.text(timestamp, 190, startY + 7, { align: 'right' });

    doc.setFontSize(10);
    let textY = startY + 20;

    doc.text(`Razão Social: ${razaoSocial}`, 12, textY);
    textY += 8;
    const cnpjMascarado = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    doc.text(`CNPJ: ${cnpjMascarado}`, 12, textY);
    textY += 8;

    doc.setFontSize(10);
    const labelValor = 'Valor: ';
    const valorFormatado = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(valor));

    doc.text(labelValor, 12, textY);
    doc.setFontSize(12);
    doc.setFont('bold');
    doc.text(valorFormatado, 12 + doc.getTextWidth(labelValor), textY);
    doc.setFont('normal');
    doc.setFontSize(10);
        
    textY += 12;

    doc.text('Código Pix:', 12, textY);
    textY += 5;
    doc.text(wrappedPixCode, 12, textY);
    

    doc.addImage(qrcode, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize);


    doc.setFontSize(12);
    doc.setFont('bold');
    const instrucaoTituloWidth = doc.getTextWidth('Instruções');
    doc.text('Instruções', pageWidth - instrucaoTituloWidth - 10, qrCodeY + qrCodeSize + 5);

    
    // Sobrepondo "Instruções" varias vezes para intesificar o negrito, 
    // visto que o bold nativo do jsPDF nao foi suficiente 
    const instrucaoX = pageWidth - instrucaoTituloWidth - 10;
    const instrucaoY = qrCodeY + qrCodeSize + 5;
    for (let i = 0; i < 3; i++) {
      doc.text('Instruções', instrucaoX, instrucaoY);
    }


    doc.setFontSize(9);
    doc.setFont('normal');
    
    const linha1Width = doc.getTextWidth('Para pagar o pedido, basta escanear o código no aplicativo de pagamentos,');
    doc.text('Para pagar o pedido, basta escanear o código no aplicativo de pagamentos,', pageWidth - linha1Width - 10, qrCodeY + qrCodeSize + 10);
    
    const linha2Width = doc.getTextWidth('através da função "pix copia e cola".');
    doc.text('através da função "pix copia e cola".', pageWidth - linha2Width - 10, qrCodeY + qrCodeSize + 15);

    doc.save('QRCode-Pix.pdf');
  }


  
}
